import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../../../components/PageHeader';
import PasswordInput from '../../../../components/PasswordInput';
import AppConfig from '../../../../config';
import { getDeviceInfo } from '../../../../hooks/useDeviceInfo';
import { t } from '../../../../lang';
import { pushSubscribe } from '../../../../serviceWorkerRegistration';
import HelperService from '../../../../services/HelperService';
import RequestService from '../../../../services/RequestService';
import WebSocketService from '../../../../services/WebSocketService';
import { appSlice } from '../../../../store/slices';

import Button from '../../../../components/Button';
import './DeviceVerificationVerify.scss';

const { routes } = AppConfig;

const DeviceVerificationVerify = () => {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const [pass, setPass] = useState();
	const publicConfig = useSelector(store => store.app.publicConfig);
	const username = useSelector(state => state.auth.username);
	const captchaConfirmRequestData = useSelector(state => state.app.captchaConfirmRequestData);
	const navigate = useNavigate();
	const intl = useIntl();

	const updatePassword = e => {
		setPass(e.target.value.trim());
	};

	const onVerify = async () => {
		const deviceInfo = await getDeviceInfo();
		const fingerPrintId = deviceInfo.fingerprintId;

		const resultHandler = async response => {
			if (response?.Status !== 'Success') {
				if (response?.ErrorCode === 'AccountBlocked') {
					HelperService.showNotification({
						type: 'error',
						title: t('Your account has been blocked'),
					});
				} else if (response?.ErrorCode === 'LoginValidateLimitReachedError') {
					HelperService.showNotification({
						type: 'error',
						title: t('Exceeded the number of registration attempts! Login blocked for {min} min {sec} sec', {
							min: Math.floor(response?.Error.SecondsLeft / 60),
							sec: response?.Error.SecondsLeft % 60,
						}),
					});
				} else if (response?.ErrorCode === 'LoginValidateError') {
					HelperService.showNotification({
						type: 'error',
						title: t('Incorrect login'),
					});
				} else if (response?.ErrorCode === 'InvalidTelegramAccountTryLoginError') {
					HelperService.showNotification({
						type: 'error',
						title: t("Error! You're trying to login to Mobile account from wrong Telegram"),
					});
				} else if (response?.ErrorCode === 'DeviceNotFound') {
					navigate({ pathname: routes.verifyDevice });
					HelperService.showNotification({
						type: 'error',
						title: response.ErrorCode,
					});
				} else if (response?.Error) {
					HelperService.showNotification({
						type: 'error',
						title: JSON.stringify(response),
					});
				} else {
					throw response;
				}
			} else {
				dispatch(appSlice.actions.setToken(response.Token));
				navigate(routes.mainPage, { replace: !!captchaConfirmRequestData });
				dispatch(appSlice.actions.setCaptchaConfirmRequestData());
				pushSubscribe();
				try {
					WebSocketService.DoConnection(publicConfig.apiUrl, response.Token);
				} catch (error) {
					console.log(error);
				}
			}
		};

		const failHandler = error => {
			RequestService.BaseErrorFunc(error);
		};

		try {
			setLoading(true);

			const response = await RequestService.Login(
				username.trim(),
				pass.trim(),
				null,
				deviceInfo,
				resultHandler,
				failHandler
			);

			setLoading(false);

			resultHandler(response, deviceInfo);
		} catch (error) {
			failHandler(error);
		}
	};

	return (
		<div className='DeviceVerificationVerify'>
			<PageHeader header='Confirm login' subheader='Enter your password to continue' />
			<div className='DeviceVerificationVerify__body'>
				<div>
					<PasswordInput
						placeholder={intl.formatMessage({ id: 'Enter your password' })}
						value={pass}
						onChange={updatePassword}
						className='FormBlock'
						maxLength={64}
						autoFocus
					/>
				</div>
			</div>
			<div className='DeviceVerificationVerify_vp-button'>
				<Button loading={loading} disabled={!pass} onClick={onVerify}>
					{t('Continue')}
				</Button>
			</div>
		</div>
	);
};

export default DeviceVerificationVerify;
